module.exports = "<div class=\"modal-content\">\r\n  <div class=\"modal-header\">\r\n    <h3 class=\"modal-title\">Delete user</h3>\r\n  </div>\r\n  <div class=\"modal-body\">\r\n    Are you sure you want to delete the user?\r\n  </div>\r\n  <div class=\"modal-footer\">\r\n    <button class=\"btn btn-danger pull-left\" type=\"button\" (click)=\"deleteUser()\">Delete user</button>\r\n    <button class=\"btn btn-warning\" type=\"button\" (click)=\"close()\">Cancel</button>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/users/components/templates/deleteUserModal.component.html
// module id = ./src/app/users/components/templates/deleteUserModal.component.html
// module chunks = main